import { Text, View, hexColor } from "@lightningtv/solid";
import { For } from "solid-js";
import { fontFamily, isRTL, t } from "../../../translations/configuration";

const PrivacyPolicy = (props: any) => {

  const items = [
    t("one"),
    t("two"),
    t("three"),
    t("four"),
    t("five"),
  ];

  return (
    <View ref={props.ref} x={isRTL() ? 80 : 600} y={80} height={2000} width={1200} clipping>

      {/* ── Title ── */}
      <Text
        width={1200}
        contain="width"
        textAlign={isRTL() ? "right" : "left"}
        style={{
          fontSize: 32,
          color: hexColor("#f0f6fc"),
          fontWeight: isRTL() ? "normal" : "bold",
          fontFamily: fontFamily(),
        }}>
        {t("orbixUserAgreement")}
      </Text>

      {/* ── Subtitle ── */}
      <Text y={50}
        textAlign={isRTL() ? "right" : "left"}
        style={{
          fontSize: 22,
          color: hexColor("#9ca3af"),
          fontFamily: fontFamily(),
          width: 1200,
          contain: "width",
        }}>
        {t("beforeyouProcc")}
      </Text>

      {/* ── Separator ── */}
      <View y={90} width={1200} height={1} color={hexColor("#1e2a3a")} />

      {/* ── Bullet items ── */}
      <View y={110}>
        <For each={items}>
          {(item, i) => (
            <View y={i() * 110}>

              {/* Blue dot — right side in RTL */}
              <View
                x={isRTL() ? 1190 : 0} y={10}
                width={10} height={10}
                borderRadius={5}
                color={hexColor("#2563eb")}
              />

              {/* Text */}
              <Text
                x={isRTL() ? 0 : 24}
                textAlign={isRTL() ? "right" : "left"}
                style={{
                  fontSize: 20,
                  color: hexColor("#d1d5db"),
                  fontFamily: fontFamily(),
                  fontWeight: 400,
                  width: 1180,
                  contain: "width",
                  lineHeight: 32,
                }}>
                {item}
              </Text>

            </View>
          )}
        </For>
      </View>

    </View>
  );
};

export default PrivacyPolicy;
